import { addNavMenuItem } from '@vendure/admin-ui/core';

export default [
    addNavMenuItem(
        {
            id: 'promotions',
            label: 'Promotions',
            routerLink: ['/marketing', 'promotions'],
            requiresPermission: '__disable__',
        },
        'marketing',
    ),
];
